import { Activated } from "@/assets";
import { routes } from "@/consts";
import { Link } from "react-router-dom";
import { useLocale } from "@/middleware";
import { useTranslate } from "@/locales";
import { Box, Typography, useTheme } from "@mui/material";
// import { CheckCircle as VerifiedIcon } from "@mui/icons-material";

function VerifiedEmail() {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 2,
        py: 2,
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          color: "text.primary",
          mb: 1,
        }}
      >
        {t("comfirm.verified")}
      </Typography>

      <Box
        component="img"
        src={Activated}
        alt="email verified"
        sx={{
          width: 200,
          height: "auto",
          my: 3,
        }}
      />

      <Link
        to={routes.login}
        style={{
          color: theme.palette.primary.main,
          textDecoration: "none",
          fontWeight: 600,
          fontSize: "1rem",
          padding: "12px 24px",
          borderRadius: "8px",
          border: `2px solid ${theme.palette.primary.main}`,
          transition: "all 0.2s ease-in-out",
        }}
      >
        Login
      </Link>
    </Box>
  );
}

export default VerifiedEmail;
